import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, untouch} from 'redux-form';
import validate from './validate';
import { renderCheckbox, renderField } from '../../../utils/renderFields';
import { subscribeToNewsletter } from '../../../actions/auth';
import './styles.scss';

class NewsletterSubscribeForm extends React.Component {
  constructor(props){
    super(props);
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    // Hack to dismiss error message
    $('body').on('click', '.newsletter-form .form-control-feedback', function() {
      $('.newsletter-form .form-control-feedback').addClass('hidden');
    }.bind(this));
  }

  submit(values) {
    return this.props.dispatch(subscribeToNewsletter(values));
  }

  render(){
    const { error, handleSubmit, submitting, submitSucceeded } = this.props;
    const consentHtml = (<span className="d-block mt-1">I consent to email analytics tracking</span>);

    return (submitSucceeded) ? (<div className="newsletter-success-message">Sucessfully subscribed!</div>) : (
        <form onSubmit={handleSubmit(this.submit)} className="newsletter-form form-inline align-items-center justify-content-start">
          <span className={error ? 'has-danger' : ''}>
            <span className="u-fontSize-11 form-control-feedback">{error}</span>
          </span>
          <Field component={renderField} name="email" type="email" label="Enter E-Mail Address" className="form-control u-textSize-16" hiddenLabel />
          <input type="submit" value="Subscribe" id="submit" className="btn btn-primary" disabled={submitting} />
          <div className="form-group">
          <Field name="tracking_consent" component={renderCheckbox} className="form-check-input"
                 labelHTML={consentHtml} labelClassName="u-textSize-12" />
          </div>
        </form>
    );
  }
}

NewsletterSubscribeForm = reduxForm({form:'newsletter-subscribe', validate, fields:['email'], initialValues: { tracking_consent: true }})(NewsletterSubscribeForm);
export default connect(null)(NewsletterSubscribeForm);
